<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat desktop apps",
    "pageDesc":"Create desktop apps that work seamlessly on devices so your users can leverage on the powers of offline experience.",
    "mantra":"Work offline with |custom desktop apps.",
    "mantraDesc":"Reimaging desktop apps with cloud techniques that depend totally on using modern cross apps technology. With simplicity in mind, we approach your different needs with beautiful and user friendly interface that takes down your business complexity and works on Mac, windows, linux .. etc. ",
    "sec1":"Connect on local devices.",
    "sec1Items":{
      "1":{
        "title":"Business analysis",
        "desc":"Working closely with you to understand the needs behind developing the solution and outlining all the possible required features."
      },
      "2":{
        "title":"Desktop app architecture",
        "desc":"Putting your industry in mind, we plan for the solution development to suit your users needs whether they are internal employees or world wide audience."
      },
      "3":{
        "title":"Desktop app development",
        "desc":"During the development stage, we focus on usability and performance by testing it against complex tasks. And as security plays a critical rule, we use multilayer protection to ensure your data is always safe. "
      },
      "4":{
        "title":"Launch and maintenance",
        "desc":"Getting the app into the real world, celebrating success then conducting continuous tests and iterations to further enhance the performance and user experience based on the analytics and reports collected."
      }
    },
    "sec2":"We leverage on the powers of electron to build custom desktop apps.",
    "sec2Items":{
      "1":{
        "title":"UX driven",
        "desc":"Avoiding the traditional and old layouts  and practices of desktop applications and stepping with you into the modern era where user experience and branding drive the whole design process."
      },
      "2":{
        "title":"High performance",
        "desc":"Whether you it's a p[hotoshop or skype similar, enjoy all the functionality you need with smooth experience and no crushes or lags."
      },
      "3":{
        "title":"Cross platforms",
        "desc":"One solution fits all. We develop your desktop app to be used across different operating systems and devices without lags or issues."
      }
    },
    "cta":"Get your installable  <br> app."
  },
  "ar": {
    "pageTitle":"تطبيقات سطح المكتب",
    "pageDesc":"نعمل على تصميم وبرمجة تطبيقات سطح المكتب التي تعمل بسلاسة على الأجهزة ليتمكن المستخدمين من الاستفادة من تجربة الأوفلاين.",
    "mantra":"تطبيقات سطح المكتب |لتجربة مختلفة خارج المتصفح.",
    "mantraDesc":"نقوم  بتصميم تطبيقات سطح المكتب باستخدام التقنيات السحابية التي تعتمد كليًا على استخدام تكنولوجيا التطبيقات الحديثة عبر الأجهزة. نضع البساطة في اعتبارنا، ولهذا نخلق واجهات يسهل عليك استخدامها والتي تعمل على أجهزة الويندوز والماك و اللينكس.",
    "sec1":"تواصل عبر تطبيقات الأجهزة المحلية",
    "sec1Items":{
      "1":{
        "title":"تحليل الأعمال",
        "desc":"نعمل عن قرب معك لفهم الاحتياجات الكامنة وراء برمجة تطبيق سطح المكتب وتحديد جميع المميزات المطلوبة."
      },
      "2":{
        "title":"بنية تطبيق سطح المكتب",
        "desc":"نفهم الصناعة التي تعمل بها، ثم نخطط لبرمجة الحلول التي تناسب احتياجات المستخدمين سواء كانوا موظفين داخليين أو جمهورًا عالميًا."
      },
      "3":{
        "title":"برمجة تطبيق سطح المكتب",
        "desc":"خلال البرمجة، نركز على قابلية الاستخدام والأداء من خلال اختباره مقابل المهام المعقدة. ونظرًا لأن الأمان يلعب أهم دور، فإننا نستخدم الحماية متعددة الطبقات لضمان سلامة بياناتك دائمًا."
      },
      "4":{
        "title":"الإطلاق والصيانة",
        "desc":"نجري الاختبارات والمراجعات لتحسين الأداء وتجربة المستخدم استنادًا إلى التحليلات والتقارير التي يتم جمعها."
      }
    },
    "sec2":"منهجية بناء تطبيقات سطح المكتب",
    "sec2Items":{
      "1":{
        "title":"التفكير في تجربة المستخدم",
        "desc":"نتجنب المخططات والممارسات التقليدية القديمة لتطبيقات سطح المكتب ونفكر معك في التقنيات الحديثة التي تقود تجربة المستخدم والعلامة التجارية أثناء عملية التصميم بأكملها."
      },
      "2":{
        "title":"الاهتمام بالأداء العالي",
        "desc":"سواء كنت تشبه الفوتوشوب أو سكايب، سوف نوفر لك الوظائف التي تحتاج إليها مع تجربة سلسة بدون مشكلات أو أعطال."
      },
      "3":{
        "title":"توفير تطبيقات للمنصات المختلفة",
        "desc":"حل واحد يناسب الجميع. نقوم ببرمجة تطبيق سطح المكتب الخاص بك لاستخدامه عبر أنظمة التشغيل والأجهزة المختلفة دون أي تأخير أو مشكلات."
      }
    },
    "cta":"احصل على تطبيقك <br> الآن!"
  }
}
</i18n>
